(() => {
 const dialog=document.getElementById('BieCheckoutLogin');
 if(!dialog||dialog.dataset.ready)return;
 dialog.dataset.ready='true';
 let pending=null;
 let guestAccepted=false;
 const selector='button[name="checkout"],input[name="checkout"],#CartDrawer-Checkout,#checkout';
 function show(event,button,form){
  if(guestAccepted||!button||button.disabled||button.getAttribute('aria-disabled')==='true')return;
  if(!['cart','CartDrawer-Form'].includes(form?.getAttribute('id')))return;
  if(!dialog.open){try{dialog.showModal()}catch{return}}
  pending={button,form};
  event.preventDefault();
  event.stopImmediatePropagation();
 }
 window.addEventListener('click',event=>{
  const button=event.target.closest?.(selector);
  if(button)show(event,button,button.form);
 },true);
 window.addEventListener('submit',event=>{
  const button=event.submitter;
  if(button?.matches(selector))show(event,button,event.target);
 },true);
 dialog.querySelector('.bie-login__close').addEventListener('click',()=>dialog.close());
 dialog.querySelector('.bie-login__guest').addEventListener('click',()=>{
  const target=pending;
  pending=null;
  dialog.close();
  if(!target)return;
  guestAccepted=true;
  const button=target.button.isConnected
   ? target.button
   : document.querySelector(target.form.getAttribute('id')==='cart' ? '#checkout' : '#CartDrawer-Checkout');
  if(button&&!button.disabled)button.click();
 });
 dialog.addEventListener('close',()=>{pending=null});
})();